/**
 * Marketing Shine Border
 *
 * Traveling edge highlight for dark Context Bank plates
 * (Magic UI border-beam / Aceternity moving-border energy).
 */

'use client'

import { ReactNode } from 'react'
import { motion } from 'motion/react'

import { cn } from '@/lib/utils'

export function MarketingShineBorder({
  children,
  className,
  duration = 12
}: {
  children: ReactNode
  className?: string
  duration?: number
}) {
  return (
    <div className={cn('relative overflow-hidden rounded-[2rem] p-px', className)}>
      <motion.div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-1/2 aspect-square w-[140%] -translate-x-1/2 -translate-y-1/2"
        style={{
          background:
            'conic-gradient(from 0deg, transparent 0 72%, rgba(186,198,214,0.7) 78%, rgba(255,255,255,0.55) 82%, transparent 88% 100%)'
        }}
        animate={{ rotate: 360 }}
        transition={{ duration, repeat: Infinity, ease: 'linear' }}
      />
      <div className="relative z-10 overflow-hidden rounded-[calc(2rem-1px)] bg-slate-950 dark:bg-[rgb(10,14,20)]">
        {children}
      </div>
    </div>
  )
}
